module.exports = __webpack_public_path__ + "static/learn-and-earn-agenda-e86841c75987c3842e6baf1ac650fd7d.svg";